module.exports = __webpack_public_path__ + "fonts/4.svg";